export const TabRoutes = {
  homeScreen: 'homeScreen',
  playScreen: 'playScreen',
  learningScreen: 'learningScreen',
  readScreen: 'readScreen',
  profileScreen: 'profileScreen',
  membershipScreen: 'membershipScreen'
} as const
